import { faEdit, faShare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import ShareTrainingDocument from "./ShareTrainingDocument";
import DeleteTrainingDocument from "./DeleteTrainingDocument";
import EditTrainingDocument from "./EditTrainingDocument";

const DocumentActions = ({
  documentId,
  document,
  setReload,
  onUpdate,
  isForwarded = false,
}) => {
  const [openModal, setOpenModal] = useState("");

  const closeModal = () => setOpenModal("");

  if (isForwarded) {
    return null;
  }

  return (
    <div className="d-flex align-items-center gap-2 documentActionsBar">
      <button
        className="docActionBtn docActionBtn--edit"
        title="Edit"
        onClick={() => setOpenModal("Edit")}
      >
        <FontAwesomeIcon icon={faEdit} />
      </button>

      {!isForwarded && (
        <button
          className="docActionBtn docActionBtn--share"
          title="Share"
          onClick={() => setOpenModal("Share")}
        >
          <FontAwesomeIcon icon={faShare} />
        </button>
      )}

      <button
        className="docActionBtn docActionBtn--delete"
        title="Delete"
        onClick={() => setOpenModal("Delete")}
      >
        <FontAwesomeIcon icon={faTrash} />
      </button>

      {openModal === "Share" && (
        <ShareTrainingDocument onClose={closeModal} documentId={documentId} />
      )}

      {openModal === "Delete" && (
        <DeleteTrainingDocument
          onClose={closeModal}
          documentId={documentId}
          setReload={setReload}
        />
      )}

      {openModal === "Edit" && (
        <EditTrainingDocument
          onClose={closeModal}
          document={document}
          onUpdate={onUpdate}
        />
      )}
    </div>
  );
};

export default DocumentActions;
